import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../../BusinessInfo/css/BusinessInfo.css';
import Text from '../../../common/Text.js';
import design1 from '../img/sotec_img_programming_1.png';
import design2 from '../img/sotec_img_programming_2.png';
import design3 from '../img/sotec_img_programming_3.png';

// 사업소개 (리뉴얼) - 설계
function Development() {
    

    useEffect(() => {


        const options = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.5
    
        };
  
  
        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv1');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".Cont1_1")

        ims.forEach(img =>
            observer.observe(img)
        );
    

        // Intersection Observer 인스턴스
        const observer2 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv2');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims2 = document.querySelectorAll(".Cont1_2")

        ims2.forEach(img =>
            observer2.observe(img)
        );
    


        // Intersection Observer 인스턴스
        const observer3 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv3');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims3 = document.querySelectorAll(".Cont1_3")

        ims3.forEach(img =>
            observer3.observe(img)
        );

        

        // Intersection Observer 인스턴스
        const observer4 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv4');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims4 = document.querySelectorAll(".box1_img")

        ims4.forEach(img =>
            observer4.observe(img)
        );

        
        // Intersection Observer 인스턴스
        const observer5 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv5');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims5 = document.querySelectorAll(".box2_img")

        ims5.forEach(img =>
            observer5.observe(img)
        );
    

        
        // Intersection Observer 인스턴스
        const observer6 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv6');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims6 = document.querySelectorAll(".box3_img")

        ims6.forEach(img =>
            observer6.observe(img)
        );
    
    
    
    
            
    
          }, [])
    
    


    return (
        <div class = 'groupa' style={{display:'flex', justifyContent : 'center'}}>

            <div class="page"> 

 
                <div class="Cont_1" > 
                <div class="Cont1_1" > 
                    <Text  variant="px32w700B"  className='MidTitle'>조선해양산업의 혁신을 주도하는 첨단 스마트 기술 솔루션</Text>
                    </div>
            
            <div class="Cont1_2" > 
                <Text  variant="px28w400"  className='SmallTitle'>IT 솔루션으로 디지털 전환과 스마트화를 선도합니다.</Text> 
                </div>

<div class="Cont1_3" > 
    <Text variant="px20w400" className='Contents'> 디지털 전환과 스마트 기술을 기반으로 업무 효율성과 생산성을 최적화하는 솔루션을 제공하여 고객 맞춤형 시스템을 개발 및 유지보수 하고 있습니다. 강력한 시스템 보안체계를 구축하여 설계와 생산과정에서의 데이터 보호를 강화하고 고객의 중요한 정보를 안전하게 관리합니다. 고객의 요구에 맞는 프로그램 개발의 도입과 안전성, 보안을 최우선으로 지속적인 기술지원을 제공합니다.</Text>
                </div>
                </div>

                <div class="boxFrame">

                    <Text  variant="px32w700B"  className='MidTitle'>대표 프로젝트</Text>

                    <div class="Contents_GRP">

                        <div class="box1">
                        <div class="box1_img" >
                            <img class="proj_img"  src={design1} ></img>
                            </div>
                            <div class="box1_child" >
                                <Text variant="px24w600_B" className='proj_nm'>Mobile Drive Thru</Text>
                                <Text variant="px18w400_B" className='proj_nm_Cnts'>출입 절차를 간소화와 동시에 야드 내 내비게이션을 사용할 수 있는 시스템입니다.</Text>
                            </div>

                        </div>


                        <div class="box2">

                            <div class="box2_child" >
                                <Text variant="px24w600_B" className='proj_nm'>Symphony</Text>
                                <Text variant="px18w400_B" className='proj_nm_Cnts'>PLM I/F를 통한 데이터 수집 및 집계를 통해 생산 업무 시각화 시스템입니다.</Text>
                            </div>
                            <div class="box2_img" >
                                 <img class="proj_img2"  src={design2} ></img>
                                 </div>
                        </div>


                        <div class="box3">

                <div class="box3_img" >
                            <img class="proj_img3"  src={design3} ></img>
                            </div>
                            <div class="box3_child">
                                <Text variant="px24w600_B" className='proj_nm'>자율 운항 시스템</Text>
                                <Text variant="px18w400_B" className='proj_nm_Cnts'>인공지능 등 첨단 기술을 운항 시스템에 접목한 완전 자율운항 시스템입니다.</Text>
                            </div>

                        </div>
                    </div>
                </div>

            </div >

        </div>
     );
 }
 
 export default Development;